export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              欢迎与我们取得联系，共同打造更好的高清观影平台
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
              <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 flex-shrink-0">
                <i className="ri-mail-send-line text-2xl md:text-3xl"></i>
              </div>
              <div className="text-center md:text-left flex-1">
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">
                  内容合作 &amp; 资源投稿
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                  如果您有优质高清影视资源推荐或希望与我们建立内容合作关系，欢迎通过邮件与我们取得联系。我们珍视每一位合作伙伴的建议与支持。
                </p>
                <a
                  href="mailto:contact@mushroomcinema.example.com"
                  className="inline-flex items-center gap-2 px-5 py-2.5 text-sm font-medium bg-accent-500 text-background-50 rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-mail-line"></i>
                  发送邮件
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}